<template>
  <!-- Markdown links. The default ProseA, plus: an in-text link to the app's sign-up page carries the
       conversion attributes every CTA needs (data/conversion-events.ts), so trial starts from blog
       and guide prose are counted. 22 posts linked to /signup with no attributes, so those clicks
       sent no conversion event. -->
  <NuxtLink
    :href="props.href"
    :target="props.target"
    :data-conversion-event="signup ? 'start_free_click' : undefined"
    :data-conversion-label="signup ? 'In-text trial link' : undefined"
    :data-conversion-location="signup ? route.path : undefined"
    :data-conversion-plan="signup && plan ? plan : undefined"
  >
    <slot />
  </NuxtLink>
</template>

<script setup>
const props = defineProps({
  href: {
    type: String,
    default: "",
  },
  target: {
    type: String,
    default: undefined,
    required: false,
  },
});

const route = useRoute();
const signup = computed(() => /^https:\/\/app\.workspace369\.com\/signup(?:[/?#]|$)/.test(props.href));
const plan = computed(() => {
  if (!signup.value) return "";
  try {
    return new URL(props.href).searchParams.get("plan") || "";
  } catch {
    return "";
  }
});
</script>
